import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
const src = '/images/brands/personly-logo.svg';
interface Props {
  alt: string;
  size?: number;
}
const BrandJumbotron = t0 => {
  const $ = _c(3);
  const {
    alt,
    size: t1
  } = t0;
  const size = t1 === undefined ? 175 : t1;
  let t2;
  if ($[0] !== alt || $[1] !== size) {
    t2 = <div className="flex flex-1 flex-col justify-center items-center"><div><Image src={src} width={size} height={size} alt={alt} priority={true} /></div></div>;
    $[0] = alt;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default BrandJumbotron;